import { useDataTableContext } from "../../../contexts/DataTableContext";
import Modal from "../../Modal/Modal";
import AccessorTree from "./AccessorTree";

import "./SelectColumnsModal.scss";

export default function SelectColumnsModal() {
	const { isSelectColumnsModalOpen, setIsSelectColumnsModalOpen } = useDataTableContext()!;

	const onClose = () => setIsSelectColumnsModalOpen(false);

	return (
		<Modal title="Select columns" className="add-columns" open={isSelectColumnsModalOpen} onClose={onClose}>
			<AccessorTree onApplied={onClose} />
		</Modal>
	);
}
